import { useEffect, useState } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import api from "../lib/api";
import VideoPlayer from "../components/VideoPlayer";
import EmbedPlayer from "../components/EmbedPlayer";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function resolveUrl(url) {
  if (!url) return url;
  return url.startsWith("/api/files/") ? `${BACKEND_URL}${url}` : url;
}

export default function Watch() {
  const { kind, id } = useParams();
  const [params] = useSearchParams();
  const epId = params.get("ep");
  const navigate = useNavigate();
  const [content, setContent] = useState(null);
  const [episode, setEpisode] = useState(null);
  const [nextEp, setNextEp] = useState(null);

  useEffect(() => {
    if (kind === "series") {
      api.get(`/series/${id}`).then((r) => {
        setContent(r.data);
        const eps = r.data.episodes || [];
        const idx = epId ? eps.findIndex((e) => e.id === epId) : 0;
        setEpisode(eps[idx]);
        setNextEp(eps[idx + 1] || null);
      });
    } else {
      api.get(`/movies/${id}`).then((r) => setContent(r.data));
    }
  }, [kind, id, epId]);

  const onProgress = (pct) => {
    if (!content) return;
    const item = kind === "series" ? episode : content;
    if (!item) return;
    api.post("/continue-watching", {
      contentId: content.id,
      contentType: kind === "series" ? "episode" : "movie",
      progress: pct,
      title: kind === "series" ? `${content.title} - ${item.title}` : content.title,
      posterUrl: content.posterUrl,
      seriesId: kind === "series" ? content.id : null,
    }).catch(() => {});
  };

  const skipNext = () => {
    if (nextEp) navigate(`/watch/series/${content.id}?ep=${nextEp.id}`);
  };

  if (!content || (kind === "series" && !episode)) {
    return <div className="min-h-screen bg-black flex items-center justify-center text-white">Loading...</div>;
  }

  const activeItem = kind === "series" ? episode : content;
  const source = activeItem.videoSource || "direct";
  const title = kind === "series" ? `${content.title} – S${episode.seasonNumber}E${episode.episodeNumber}: ${episode.title}` : content.title;

  if (source === "embed_code" && activeItem.embedCode) {
    return <EmbedPlayer embedCode={activeItem.embedCode} title={title} />;
  }
  if (source === "embed_url" && activeItem.videoUrl) {
    return <EmbedPlayer embedUrl={activeItem.videoUrl} title={title} />;
  }

  // direct or upload — use native HLS player
  const src = resolveUrl(activeItem.videoUrl);
  return (
    <VideoPlayer
      src={src}
      title={title}
      onProgress={onProgress}
      hasNext={!!nextEp}
      onSkipNext={skipNext}
      onEnd={skipNext}
    />
  );
}
